export const version = '1.40.0';
